import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import ParameterWithSimpleInput from '../inputs/ParameterWithSimpleInput'
import ParameterWithSwitch from '../inputs/ParameterWithSwitch'
import { Stack } from '@mui/material'
import { shallowEqual, useSelector } from 'react-redux'
import hydroValidOnlyHelp from 'assets/pictures/observatory/hydroValidOnlyHelp.webp'
import hydrometryHorizonsHelp from 'assets/pictures/observatory/hydrometryHorizonsHelp.webp'
import hydrometryLimitHistoHelp from 'assets/pictures/observatory/hydrometryLimitHistoHelp.webp'
import { INPUT_TYPES } from 'components/forms/SimpleInput'
import FrequencyDatas, { FREQUENCY_STATIONS_TYPES } from '../FrequencyDatas'
import { toUpper } from 'lodash'
import ShowDataTypesRules from '../ShowDataTypesRules'
import HydroDataTypes from '../HydroDataTypes'
import ParameterWithSuperMultiAutocomplete from '../inputs/ParameterWithSuperMultiAutocomplete'
import { getQualifications } from 'utils/QualityUtils'

const HydrometryParameters = ({
    isWidget = false,
    isGlobal = false,
    defaultProps = {},
}) => {
    const {
        hydrometryDataTypes,
    } = useSelector(store => ({
        hydrometryDataTypes: store.HydrometryReducer.hydrometryDataTypes,
    }), shallowEqual)

    return (
        <Stack spacing={1.25}>
            <ParameterWithSwitch
                {...defaultProps}
                parameter={isWidget ? 'hydroValidOnlyWidget' : 'hydroValidOnly'}
                title={i18n.validatedDataOnly}
                helpImage={hydroValidOnlyHelp}
            />
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='hydroQualificationType'
                options={getQualifications()}
                title={i18n.consideredQualificationType}
                keyValue='code'
                multiple
            />
            <ParameterWithSimpleInput
                {...defaultProps}
                parameter={isWidget ? 'hydrometryHorizonsWidget' : 'hydrometryHorizons'}
                title={i18n.chartHorizons}
                helpImage={hydrometryHorizonsHelp}
                placeholder='7,30,90,365,HISTO'
            />
            <ParameterWithSimpleInput
                {...defaultProps}
                parameter={isWidget ? 'hydrometryLimitHistoWidget' : 'hydrometryLimitHisto'}
                title={i18n.chartHistoryLimit}
                helpImage={hydrometryLimitHistoHelp}
                placeholder='265'
                type={INPUT_TYPES.int}
            />
            <FrequencyDatas module={isWidget ? null : toUpper(module.module)} stationType={FREQUENCY_STATIONS_TYPES.hydro} {...defaultProps} />
            {!isWidget && <ShowDataTypesRules link='hydrometry/hydrometryOptions' {...defaultProps} />}
            <HydroDataTypes
                {...defaultProps}
                hydrometryDataTypes={hydrometryDataTypes}
                isGlobal={isGlobal}
            />
        </Stack>
    )
}

HydrometryParameters.propTypes = {
    isWidget: PropTypes.bool,
    isGlobal: PropTypes.bool,
    defaultProps: PropTypes.shape({}),
}

export default HydrometryParameters
